export const getLang = () => {
  return localStorage.getItem("lang") || "tj";
};

export const setLang = (lang) => {
  localStorage.setItem("lang", lang);
  window.location.reload();
};
